import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getNetworkChatContact } from "../../../endpoints/referral.service";
import ChatList from "../../MessagesPage/components/ChatList";
import PropTypes from "prop-types";

export default function MessagesTab({ candidateId: selectedCandidateId, jobId: selectedJobId }) {
  const route = useParams();
  const candidateId = selectedCandidateId || route.candidateId;
  const jobId = selectedJobId || route.jobId;
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setContact(null);
    setError("");
    setLoading(true);
    if (![candidateId, jobId].every(id => typeof id === "string" && /^[a-f\d]{24}$/i.test(id))) {
      setError("This matched-job conversation is unavailable.");
      setLoading(false);
      return;
    }
    getNetworkChatContact(candidateId, jobId).then(response => {
      if (cancelled) return;
      if (!response?.success || !response?.data?.userId || response.data.jobId !== jobId) {
        throw new Error("Unavailable matched-job conversation");
      }
      setContact(response.data);
    }).catch(() => {
      if (!cancelled) setError("This matched-job conversation is unavailable or the candidate is no longer in your network.");
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [candidateId, jobId]);

  if (loading) return <p className="p-6 text-sm">Loading candidate conversation...</p>;
  if (error) return <p role="alert" className="p-6 text-sm">{error}</p>;

  const name = [contact.firstName, contact.lastName].filter(Boolean).join(" ");
  const selectedContact = {
    jobId: contact.jobId, jobTitle: contact.jobTitle,
    participantDetails: { userId: contact.userId, _id: contact.userId, name,
      profilePic: contact.profilePic, referenceId: contact.refNo },
  };

  return <section aria-label="Matched-job candidate messages" className="flex flex-col flex-1 min-h-0">
    <div className="rounded-md bg-[#F1F5F9] px-4 py-3 text-xs">
      <p className="font-semibold">{name}</p>
      <p className="mt-1">{contact.jobTitle}{contact.jobRefNo ? ` - ${contact.jobRefNo}` : ""}</p>
    </div>
    <ChatList key={`${contact.userId}:${contact.jobId}`} selectedContact={selectedContact} />
  </section>;
}

MessagesTab.propTypes = { candidateId: PropTypes.string, jobId: PropTypes.string };
